const stylesDropdown = {
  container:  (provided, state) => ({

  }),
  control: (provided, state) => ({
    display: 'flex',
    justifyContent: 'space-between',
    outline: '0!important',
    position: 'relative',
    WebkitTransition: 'all 100ms',
    transition: 'all 100ms',
    boxSizing: 'border-box',
    paddingLeft: '20px',
    fontSize: '16px',
    outline: '0',
    width: '100%',
  }),
  valueContainer: (provided, state) => ({
    // padding: '14px 0'
  }),
  input: (provided, state) => ({
    visibility: 'visible',
    color: 'hsl(0, 0%, 20%)',
    boxSizing: 'border-box'
  })
}

export default stylesDropdown